(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-heitok-about-r2"]) return;
  try {
    
  (() => {
    const copyText = (text, button) => {
      const copiedLabel = button.dataset.copiedLabel;
      const copyLabel = button.dataset.copyLabel;
      const setCopied = () => {
        button.textContent = copiedLabel;
        window.setTimeout(() => {
          button.textContent = copyLabel;
        }, 1800);
      };

      const fallbackCopy = () => {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.top = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
        setCopied();
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(setCopied).catch(fallbackCopy);
        return;
      }

      fallbackCopy();
    };

    const initSupportDialog = (root = document) => {
      root.querySelectorAll('[data-heitok-support-trigger]').forEach((trigger) => {
        if (trigger.dataset.heitokSupportBound === 'true') return;
        trigger.dataset.heitokSupportBound = 'true';
        trigger.addEventListener('click', () => {
          const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      });

      root.querySelectorAll('[data-heitok-support-dialog]').forEach((dialog) => {
        if (dialog.dataset.heitokDialogBound === 'true') return;
        dialog.dataset.heitokDialogBound = 'true';
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      root.querySelectorAll('[data-heitok-support-close]').forEach((button) => {
        if (button.dataset.heitokCloseBound === 'true') return;
        button.dataset.heitokCloseBound = 'true';
        button.addEventListener('click', () => {
          button.closest('[data-heitok-support-dialog]').close();
        });
      });

      root.querySelectorAll('[data-heitok-support-copy]').forEach((button) => {
        if (button.dataset.heitokCopyBound === 'true') return;
        button.dataset.heitokCopyBound = 'true';
        button.addEventListener('click', () => {
          const dialog = button.closest('[data-heitok-support-dialog]');
          const email = dialog.querySelector('[data-heitok-support-email]').textContent.trim();
          copyText(email, button);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSupportDialog());
    } else {
      initSupportDialog();
    }

    document.addEventListener('shopify:section:load', (event) => initSupportDialog(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-heitok-contact"]) return;
  try {
    
  const contactCopyButtons = document.querySelectorAll('[data-heitok-copy]');

  contactCopyButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      const email = button.dataset.heitokCopy;
      const copiedLabel = button.dataset.copiedLabel;
      const defaultLabel = button.dataset.copyLabel;
      const status = button.parentElement.querySelector('.heitok-contact-copy-status');

      try {
        await navigator.clipboard.writeText(email);
        button.textContent = copiedLabel;
        if (status) {
          status.textContent = email;
        }
        window.setTimeout(() => {
          button.textContent = defaultLabel;
          if (status) {
            status.textContent = '';
          }
        }, 2200);
      } catch (error) {
        if (status) {
          status.textContent = email;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
